<div id="dialog-create-ttd-category">
  <button mat-icon-button
          id="button-dialog-close"
          class="mat-icon-button-small"
          data-cy="button-dialog-close"
          [mat-dialog-close]="true">
    <mat-icon>clear</mat-icon>
  </button>
  <h1 mat-dialog-title>Add {{ getTtdCategoryTitle() }} Category</h1>

  <div mat-dialog-content class="mat-body-1">
    <p>Create a new {{ getTtdCategoryTitle() }} Category.</p>
    <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
    <mat-form-field data-cy="input-category-filter">
      <mat-label>Select parent category for your new category</mat-label>
      <mat-select [formControl]="selectedParentId" name="parentId">
        <mat-option *ngFor="let category of categories | categorySort" [value]="category.providerElementId">
          {{ category.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>New Category Name</mat-label>
      <input [formControl]="categoryName" matInput name="categoryName"/>
      <mat-hint>Please do not use special characters like , ‘ “ ^ or tab, (TTD api documentation)</mat-hint>
    </mat-form-field>

  </div>

  <div mat-dialog-actions>
    <button (click)="reset()" [disabled]="isRequesting" id="btn-reset-ttd-category" mat-button>Reset</button>
    <button *ngIf="!isRequesting"
            [disabled]="selectedParentId.invalid || categoryName.invalid"
            mat-button
            id="btn-create-ttd-category"
            (click)="create()">Create
    </button>
    <mat-spinner *ngIf="isRequesting" diameter="24"></mat-spinner>
  </div>
</div>
